<template>
    <div>
        <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onSubmit)" autocomplete="off">
                <div class="row">
                    <div class="col-xl-6">
                        <label for="classCode">Mã lớp <span class="text-danger">*</span></label>
                        <ValidationProvider name="Mã lớp" rules="required" v-slot="{ errors, classes }" vid="34343434">
                            <el-input v-model="form.classCode" placeholder="Nhập mã lớp" id="classCode" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </ValidationProvider>
                    </div>
                    <div class="col-xl-6">
                        <label for="content">Nội dung gia sư <span class="text-danger">*</span></label>
                        <ValidationProvider name="Nội dung" rules="required" v-slot="{ errors }">
                            <el-input v-model="form.tutorContent" placeholder="Nhập nội dung gia sư" clearable
                                id="content" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </ValidationProvider>
                    </div>
                    <div class="col-xl-6">
                        <label for="zaloLink">Link zalo lớp đệm <span class="text-danger">*</span></label>
                        <ValidationProvider name="Link Zalo" rules="required|zalo_url" v-slot="{ errors }">
                            <el-input v-model="form.zaloLink" placeholder="Nhập link zalo lớp đệm" id="zaloLink" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </ValidationProvider>
                    </div>
                    <div class="col-xl-6">
                        <label for="levelId">Trình độ học <span class="text-danger">*</span></label>
                        <ValidationProvider name="Trình độ" rules="required" v-slot="{ errors }">
                            <el-select v-model="form.levelId" placeholder="Chọn trình độ của lớp" class="w-100"
                                clearable filterable id="levelId">
                                <el-option v-for="lv in levelList" :key="lv.id" :label="lv.name" :value="lv.id" />
                            </el-select>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </ValidationProvider>
                    </div>
                    <div class="col-xl-6">
                        <label for="date">Ngày học <span class="text-danger">*</span></label>
                        <ValidationProvider name="Ngày học" rules="required" v-slot="{ errors }">
                            <el-date-picker v-model="form.tutorDate" type="date" class="w-100" placeholder="Chọn ngày"
                                format="dd-MM-yyyy" value-format="yyyy-MM-dd" :picker-options="pickerOptions"
                                id="date" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </ValidationProvider>
                    </div>
                    <div class="col-xl-6">
                        <label for="tutorTime">Giờ học <span class="text-danger">*</span></label>
                        <ValidationProvider name="Giờ học" rules="required" v-slot="{ errors }">
                            <el-select v-model="form.tutorTime" placeholder="Chọn giờ học" class="w-100" clearable
                                filterable :disabled="!form.tutorDate" :loading="loadingSlot" @focus="getSlot()"
                                id="tutorTime">
                                <el-option-group v-for="group in timeSlots" :key="group.code" :label="group.name">
                                    <el-option v-for="item in group.slots" :key="item.start" :label="item.start"
                                        :value="item.start" :disabled="item.disable">
                                    </el-option>
                                </el-option-group>
                            </el-select>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </ValidationProvider>
                    </div>
                    <div class=" col-12 d-flex justify-content-end">
                        <el-button @click="comeBack()">Quay lại</el-button>
                        <el-button type="primary" class="ml-2" native-type="submit" :loading="submitting"
                            @click="handleSubmit(onSubmit)">Đặt lịch
                        </el-button>
                    </div>

                </div>
            </form>
        </ValidationObserver>
    </div>
</template>

<script>
import {
    GET_LIST_LEVEL, GET_SLOT,
} from "@/core/services/store/tutor/tutor.module";
import { formatTimeISOString } from "../../../../../core/filters";
import { POST_RETAKE_TUTORING } from "../../../../../core/services/store/tutor/tutor.module";
export default {
    name: "RetakeTutor",
    data() {
        return {
            form: {
                classCode: '',
                tutorContent: '',
                zaloLink: '',
                levelId: '',
                tutorDate: null,
                tutorTime: null,
            },
            levelList: [],
            pickerOptions: {
                disabledDate(time) {
                    // Disable tất cả ngày trước hôm nay
                    const today = new Date()
                    today.setHours(0, 0, 0, 0)
                    return time.getTime() < today.getTime()
                }
            },
            loadingSlot: false,
            timeSlots: [],
            submitting: false,
        }
    },
    methods: {
        async getApiLevelList() {
            const data = await this.$store.dispatch(GET_LIST_LEVEL)
            this.levelList = data.data
        },
        async getSlot() {
            this.timeSlots = []
            this.loadingSlot = true
            let payload = {
                subtype: 6,
                day: this.form.tutorDate,
                duration: 60
            }
            const data = await this.$store.dispatch(GET_SLOT, payload)
            if (data?.data?.slots.length) {
                const now = Date.now();

                [
                    { code: 'morning', name: 'Buổi sáng' },
                    { code: 'afternoon', name: 'Buổi chiều' },
                    { code: 'evening', name: 'Buổi tối' }
                ].forEach(shift => {
                    this.timeSlots.push({
                        code: shift.code,
                        name: shift.name,
                        slots: data.data.slots
                            .filter(s => s.code === shift.code)
                            .map(slot => ({
                                ...slot,
                                start: formatTimeISOString(slot.start),
                                disable: new Date(slot.start).getTime() < now // thêm field disable
                            }))
                    })
                })
            }
            this.loadingSlot = false
        },
        comeBack() {
            this.$emit('closeModal', false)
        },
        async onSubmit() {
            const payload = {
                class_code: this.form.classCode,
                content: this.form.tutorContent,
                zalo_link: this.form.zaloLink,
                study_level: this.form.levelId,
                study_date: this.form.tutorDate,
                study_time: this.form.tutorTime,
            }
            try {
                this.submitting = true
                await this.$store.dispatch(POST_RETAKE_TUTORING, payload)

                this.$message.success('Đặt lịch gia sư thành công')
                this.closeModal(true)
            } catch (e) {
                this.$message.error(e?.data?.message || 'Có lỗi xảy ra')
            } finally {
                this.submitting = false
            }
        },
        closeModal(isCreateSuccessful = false) {
            this.$emit('closeModal', isCreateSuccessful)
        },
    },
    mounted() {
        this.getApiLevelList()
    }
}
</script>

<style scoped>
.row>.col-xl-6 {
    margin-bottom: 20px;
}
</style>